exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download_div {\n  line-height: 0.5rem;\n  text-align: center;\n  background-color: #fbf3f3;\n  margin-top: 0.026042rem;\n}\n.download_div a {\n  cursor: pointer;\n  color: #c39696;\n}\n.download_div a:hover {\n  color: #1384e5;\n  text-decoration: underline;\n}", ""]);

// exports
